import * as Sentry from '@sentry/browser';
import {DateTime} from 'luxon';

export const MED_FORMAT = 'DD TT ZZZZ';
export const SHORT_FORMAT = 'yyyy-MM-dd';

export const formatShortDate = isoString =>
  isoString ? DateTime.fromISO(isoString).toFormat(SHORT_FORMAT) : '--';

export const formatMedDateTime = (isoString, message) => {
  if (isoString) {
    return DateTime.fromISO(isoString).toFormat(MED_FORMAT);
  }

  Sentry.captureMessage(message ?? 'Date string undefined');

  return '--';
};

export const formatShortDateRange = (start, end) =>
  `${formatShortDate(start)} to ${formatShortDate(end)}`;

export const formatProductTermRange = product => {
  if (product && (!product?.term_start_date || !product?.term_end_date)) {
    Sentry.captureMessage(
      `Term start or end date missing for product ${product.id}`
    );
  }

  return formatShortDateRange(product?.term_start_date, product?.term_end_date);
};
